/*
  Сведения для искового заявления - §6.4.5, 07.10.2026.

  Один запрос отдаёт всё, что показывает блок иска: сведения об отменённом
  приказе, районный суд по умолчанию и деньги иска. Перечитывается после
  сохранения сведений - месяцы и платёжка меняют цену иска и доплату.
*/

import { useCallback, useEffect, useState } from 'react'

import { api } from '../api/client.js'

export default function useLawsuit(accountId, enabled) {
  const [form, setForm] = useState(null)
  const [error, setError] = useState(null)

  const reload = useCallback(async () => {
    setError(null)
    try {
      setForm(await api.lawsuitForm(accountId))
    } catch (failure) {
      setError(failure)
    }
  }, [accountId])

  useEffect(() => {
    if (enabled) reload()
  }, [enabled, reload])

  return { form, error, reload }
}
